@file:OptIn(InternalResourceApi::class)

package com.karyadina.common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.karyadina.common.generated.resources/"

@delegate:ResourceContentHash(987_307_536)
internal val Res.string.task_empty_title: StringResource by lazy {
      StringResource("string:task_empty_title", "task_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28386, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15859, 40),
      ))
    }

@delegate:ResourceContentHash(-189_572_439)
internal val Res.string.task_filter_active: StringResource by lazy {
      StringResource("string:task_filter_active", "task_filter_active", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28487, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15900, 34),
      ))
    }

@delegate:ResourceContentHash(357_963_696)
internal val Res.string.task_filter_all: StringResource by lazy {
      StringResource("string:task_filter_all", "task_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28538, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15935, 27),
      ))
    }

@delegate:ResourceContentHash(1_446_178_525)
internal val Res.string.task_filter_completed: StringResource by lazy {
      StringResource("string:task_filter_completed", "task_filter_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28574, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15963, 41),
      ))
    }

@delegate:ResourceContentHash(-1_488_103_604)
internal val Res.string.task_filter_overdue: StringResource by lazy {
      StringResource("string:task_filter_overdue", "task_filter_overdue", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28624, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16005, 39),
      ))
    }

@delegate:ResourceContentHash(679_311_906)
internal val Res.string.task_filter_today: StringResource by lazy {
      StringResource("string:task_filter_today", "task_filter_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28680, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16045, 33),
      ))
    }

@delegate:ResourceContentHash(505_072_558)
internal val Res.string.task_format_days: StringResource by lazy {
      StringResource("string:task_format_days", "task_format_days", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28714, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16079, 36),
      ))
    }

@delegate:ResourceContentHash(-1_650_885_829)
internal val Res.string.task_format_overdue_days: StringResource by lazy {
      StringResource("string:task_format_overdue_days", "task_format_overdue_days", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28759, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16116, 52),
      ))
    }

@delegate:ResourceContentHash(-966_092_378)
internal val Res.string.task_format_overdue_hours: StringResource by lazy {
      StringResource("string:task_format_overdue_hours", "task_format_overdue_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28840, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16169, 53),
      ))
    }

@delegate:ResourceContentHash(1_951_095_850)
internal val Res.string.task_format_overdue_mins: StringResource by lazy {
      StringResource("string:task_format_overdue_mins", "task_format_overdue_mins", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28926, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16223, 52),
      ))
    }

@delegate:ResourceContentHash(679_311_906)
internal val Res.string.task_format_today: StringResource by lazy {
      StringResource("string:task_format_today", "task_format_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29011, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16276, 33),
      ))
    }

@delegate:ResourceContentHash(-1_863_680_928)
internal val Res.string.task_format_tomorrow: StringResource by lazy {
      StringResource("string:task_format_tomorrow", "task_format_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29045, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16310, 40),
      ))
    }

@delegate:ResourceContentHash(-1_783_043_120)
internal val Res.string.task_priority_high: StringResource by lazy {
      StringResource("string:task_priority_high", "task_priority_high", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29082, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16351, 34),
      ))
    }

@delegate:ResourceContentHash(-302_191_131)
internal val Res.string.task_priority_label: StringResource by lazy {
      StringResource("string:task_priority_label", "task_priority_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29125, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16386, 39),
      ))
    }

@delegate:ResourceContentHash(1_231_819_162)
internal val Res.string.task_priority_low: StringResource by lazy {
      StringResource("string:task_priority_low", "task_priority_low", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29193, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16426, 29),
      ))
    }

@delegate:ResourceContentHash(2_091_361_857)
internal val Res.string.task_priority_medium: StringResource by lazy {
      StringResource("string:task_priority_medium", "task_priority_medium", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29227, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16456, 36),
      ))
    }

@delegate:ResourceContentHash(-1_861_627_551)
internal val Res.string.task_priority_urgent: StringResource by lazy {
      StringResource("string:task_priority_urgent", "task_priority_urgent", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29276, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16493, 36),
      ))
    }

@delegate:ResourceContentHash(-1_844_976_419)
internal val Res.string.task_recurrence_daily: StringResource by lazy {
      StringResource("string:task_recurrence_daily", "task_recurrence_daily", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29345, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16530, 37),
      ))
    }

@delegate:ResourceContentHash(1_743_868_101)
internal val Res.string.task_recurrence_label: StringResource by lazy {
      StringResource("string:task_recurrence_label", "task_recurrence_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29395, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16568, 37),
      ))
    }

@delegate:ResourceContentHash(1_508_390_092)
internal val Res.string.task_recurrence_monthly: StringResource by lazy {
      StringResource("string:task_recurrence_monthly", "task_recurrence_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29453, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16606, 43),
      ))
    }

@delegate:ResourceContentHash(453_192_092)
internal val Res.string.task_recurrence_none: StringResource by lazy {
      StringResource("string:task_recurrence_none", "task_recurrence_none", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29505, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16650, 36),
      ))
    }

@delegate:ResourceContentHash(-1_747_142_094)
internal val Res.string.task_recurrence_weekly: StringResource by lazy {
      StringResource("string:task_recurrence_weekly", "task_recurrence_weekly", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29566, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16687, 38),
      ))
    }

@delegate:ResourceContentHash(-302_295_559)
internal val Res.string.task_stats_done: StringResource by lazy {
      StringResource("string:task_stats_done", "task_stats_done", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29633, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16726, 31),
      ))
    }

@delegate:ResourceContentHash(-1_488_103_604)
internal val Res.string.task_stats_overdue: StringResource by lazy {
      StringResource("string:task_stats_overdue", "task_stats_overdue", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29677, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16758, 38),
      ))
    }

@delegate:ResourceContentHash(-87_458_893)
internal val Res.string.task_stats_total: StringResource by lazy {
      StringResource("string:task_stats_total", "task_stats_total", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29732, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16797, 32),
      ))
    }

@delegate:ResourceContentHash(-302_295_559)
internal val Res.string.task_status_done: StringResource by lazy {
      StringResource("string:task_status_done", "task_status_done", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29769, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16830, 32),
      ))
    }

@delegate:ResourceContentHash(2_013_586_516)
internal val Res.string.task_status_in_progress: StringResource by lazy {
      StringResource("string:task_status_in_progress", "task_status_in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29814, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16863, 47),
      ))
    }

@delegate:ResourceContentHash(605_285_309)
internal val Res.string.task_status_todo: StringResource by lazy {
      StringResource("string:task_status_todo", "task_status_todo", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29890, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16911, 32),
      ))
    }

@delegate:ResourceContentHash(1_458_896_157)
internal val Res.string.task_subject_optional_label: StringResource by lazy {
      StringResource("string:task_subject_optional_label", "task_subject_optional_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29955, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16944, 59),
      ))
    }

@delegate:ResourceContentHash(460_493_375)
internal val Res.string.task_title_label: StringResource by lazy {
      StringResource("string:task_title_label", "task_title_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30043, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17004, 40),
      ))
    }

@delegate:ResourceContentHash(177_110_213)
internal val Res.string.task_title_placeholder: StringResource by lazy {
      StringResource("string:task_title_placeholder", "task_title_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30116, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17045, 62),
      ))
    }

@delegate:ResourceContentHash(-1_732_996_755)
internal val Res.string.task_tracker_title: StringResource by lazy {
      StringResource("string:task_tracker_title", "task_tracker_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30223, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17108, 42),
      ))
    }

@delegate:ResourceContentHash(-2_029_196_320)
internal val Res.string.theme_dark: StringResource by lazy {
      StringResource("string:theme_dark", "theme_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30298, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17151, 26),
      ))
    }

@delegate:ResourceContentHash(268_328_166)
internal val Res.string.theme_light: StringResource by lazy {
      StringResource("string:theme_light", "theme_light", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30337, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17178, 27),
      ))
    }

@delegate:ResourceContentHash(-1_566_989_063)
internal val Res.string.theme_system: StringResource by lazy {
      StringResource("string:theme_system", "theme_system", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30373, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17206, 28),
      ))
    }

@delegate:ResourceContentHash(-1_876_304_118)
internal val Res.string.timer_btn_end: StringResource by lazy {
      StringResource("string:timer_btn_end", "timer_btn_end", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30418, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17235, 37),
      ))
    }

@delegate:ResourceContentHash(-527_195_850)
internal val Res.string.timer_btn_stop: StringResource by lazy {
      StringResource("string:timer_btn_stop", "timer_btn_stop", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30500, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17273, 38),
      ))
    }

@delegate:ResourceContentHash(779_363_372)
internal val Res.string.timer_focused_today: StringResource by lazy {
      StringResource("string:timer_focused_today", "timer_focused_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30563, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17312, 55),
      ))
    }

@delegate:ResourceContentHash(-1_657_542_781)
internal val Res.string.timer_history: StringResource by lazy {
      StringResource("string:timer_history", "timer_history", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30659, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17368, 33),
      ))
    }

@delegate:ResourceContentHash(-300_495_084)
internal val Res.string.timer_input_task: StringResource by lazy {
      StringResource("string:timer_input_task", "timer_input_task", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30705, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17402, 56),
      ))
    }

@delegate:ResourceContentHash(1_771_898_944)
internal val Res.string.timer_label_working_on: StringResource by lazy {
      StringResource("string:timer_label_working_on", "timer_label_working_on", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30814, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17459, 46),
      ))
    }

@delegate:ResourceContentHash(-983_285_213)
internal val Res.string.timer_mantra_focus: StringResource by lazy {
      StringResource("string:timer_mantra_focus", "timer_mantra_focus", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30893, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17506, 42),
      ))
    }

@delegate:ResourceContentHash(-1_493_881_046)
internal val Res.string.timer_mantra_long_break: StringResource by lazy {
      StringResource("string:timer_mantra_long_break", "timer_mantra_long_break", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30972, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17549, 55),
      ))
    }

@delegate:ResourceContentHash(-2_065_766_636)
internal val Res.string.timer_mantra_short_break: StringResource by lazy {
      StringResource("string:timer_mantra_short_break", "timer_mantra_short_break", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31096, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17605, 52),
      ))
    }

@delegate:ResourceContentHash(-1_583_420_845)
internal val Res.string.timer_recent_activity: StringResource by lazy {
      StringResource("string:timer_recent_activity", "timer_recent_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31169, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17658, 49),
      ))
    }

@delegate:ResourceContentHash(1_335_048_660)
internal val Res.string.timer_recording: StringResource by lazy {
      StringResource("string:timer_recording", "timer_recording", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31255, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17708, 35),
      ))
    }

@delegate:ResourceContentHash(2_131_267_868)
internal val Res.string.timer_session_focus: StringResource by lazy {
      StringResource("string:timer_session_focus", "timer_session_focus", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31319, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17744, 35),
      ))
    }

@delegate:ResourceContentHash(-489_999_329)
internal val Res.string.timer_session_long_break: StringResource by lazy {
      StringResource("string:timer_session_long_break", "timer_session_long_break", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31363, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17780, 48),
      ))
    }

@delegate:ResourceContentHash(1_038_807_356)
internal val Res.string.timer_session_short_break: StringResource by lazy {
      StringResource("string:timer_session_short_break", "timer_session_short_break", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31456, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17829, 49),
      ))
    }

@delegate:ResourceContentHash(274_074_470)
internal val Res.string.timer_settings: StringResource by lazy {
      StringResource("string:timer_settings", "timer_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31530, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17879, 34),
      ))
    }

@delegate:ResourceContentHash(526_441_079)
internal val Res.string.timer_stats_streak: StringResource by lazy {
      StringResource("string:timer_stats_streak", "timer_stats_streak", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31585, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17914, 34),
      ))
    }

@delegate:ResourceContentHash(679_311_906)
internal val Res.string.timer_stats_today: StringResource by lazy {
      StringResource("string:timer_stats_today", "timer_stats_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31620, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17949, 33),
      ))
    }

@delegate:ResourceContentHash(-1_461_353_482)
internal val Res.string.timer_stats_week: StringResource by lazy {
      StringResource("string:timer_stats_week", "timer_stats_week", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31654, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17983, 32),
      ))
    }

@delegate:ResourceContentHash(-1_462_998_489)
internal val Res.string.timer_status_focusing: StringResource by lazy {
      StringResource("string:timer_status_focusing", "timer_status_focusing", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31703, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18016, 45),
      ))
    }

@delegate:ResourceContentHash(-910_317_942)
internal val Res.string.timer_status_paused: StringResource by lazy {
      StringResource("string:timer_status_paused", "timer_status_paused", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31789, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18062, 35),
      ))
    }

@delegate:ResourceContentHash(770_193_455)
internal val Res.string.timer_status_ready: StringResource by lazy {
      StringResource("string:timer_status_ready", "timer_status_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31849, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18098, 42),
      ))
    }

@delegate:ResourceContentHash(853_543_856)
internal val Res.string.timer_stop: StringResource by lazy {
      StringResource("string:timer_stop", "timer_stop", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31964, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18141, 26),
      ))
    }

@delegate:ResourceContentHash(1_110_436_851)
internal val Res.string.timer_title: StringResource by lazy {
      StringResource("string:timer_title", "timer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32003, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18168, 35),
      ))
    }

@delegate:ResourceContentHash(296_631_075)
internal val Res.string.timer_view_all_history: StringResource by lazy {
      StringResource("string:timer_view_all_history", "timer_view_all_history", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32063, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18204, 54),
      ))
    }

@delegate:ResourceContentHash(-613_941_800)
internal val Res.string.tool_name: StringResource by lazy {
      StringResource("string:tool_name", "tool_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32158, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18259, 37),
      ))
    }

@delegate:ResourceContentHash(-1_275_244_315)
internal val Res.string.translator_coming_soon: StringResource by lazy {
      StringResource("string:translator_coming_soon", "translator_coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32236, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18297, 74),
      ))
    }

@delegate:ResourceContentHash(1_870_113_914)
internal val Res.string.translator_title: StringResource by lazy {
      StringResource("string:translator_title", "translator_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32363, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18372, 40),
      ))
    }

@delegate:ResourceContentHash(136_441_814)
internal val Res.string.version_desc: StringResource by lazy {
      StringResource("string:version_desc", "version_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32416, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18413, 80),
      ))
    }

@delegate:ResourceContentHash(-1_688_495_296)
internal val Res.string.version_format_args: StringResource by lazy {
      StringResource("string:version_format_args", "version_format_args", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32577, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18494, 35),
      ))
    }

@delegate:ResourceContentHash(1_292_986_417)
internal val Res.string.version_label: StringResource by lazy {
      StringResource("string:version_label", "version_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32613, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18530, 41),
      ))
    }

@delegate:ResourceContentHash(766_513_586)
internal val Res.string.weekly_review_card_desc: StringResource by lazy {
      StringResource("string:weekly_review_card_desc", "weekly_review_card_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32675, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18572, 75),
      ))
    }

@delegate:ResourceContentHash(-1_461_763_092)
internal val Res.string.weekly_review_title: StringResource by lazy {
      StringResource("string:weekly_review_title", "weekly_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32827, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18648, 47),
      ))
    }

@delegate:ResourceContentHash(1_157_582_943)
internal val Res.string.welcome_desc: StringResource by lazy {
      StringResource("string:welcome_desc", "welcome_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 32923, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18696, 64),
      ))
    }

@delegate:ResourceContentHash(72_666_319)
internal val Res.string.welcome_title: StringResource by lazy {
      StringResource("string:welcome_title", "welcome_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 33028, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18761, 41),
      ))
    }

@delegate:ResourceContentHash(-1_813_430_552)
internal val Res.string.workspace_format: StringResource by lazy {
      StringResource("string:workspace_format", "workspace_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 33118, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18803, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("task_empty_title", Res.string.task_empty_title)
  map.put("task_filter_active", Res.string.task_filter_active)
  map.put("task_filter_all", Res.string.task_filter_all)
  map.put("task_filter_completed", Res.string.task_filter_completed)
  map.put("task_filter_overdue", Res.string.task_filter_overdue)
  map.put("task_filter_today", Res.string.task_filter_today)
  map.put("task_format_days", Res.string.task_format_days)
  map.put("task_format_overdue_days", Res.string.task_format_overdue_days)
  map.put("task_format_overdue_hours", Res.string.task_format_overdue_hours)
  map.put("task_format_overdue_mins", Res.string.task_format_overdue_mins)
  map.put("task_format_today", Res.string.task_format_today)
  map.put("task_format_tomorrow", Res.string.task_format_tomorrow)
  map.put("task_priority_high", Res.string.task_priority_high)
  map.put("task_priority_label", Res.string.task_priority_label)
  map.put("task_priority_low", Res.string.task_priority_low)
  map.put("task_priority_medium", Res.string.task_priority_medium)
  map.put("task_priority_urgent", Res.string.task_priority_urgent)
  map.put("task_recurrence_daily", Res.string.task_recurrence_daily)
  map.put("task_recurrence_label", Res.string.task_recurrence_label)
  map.put("task_recurrence_monthly", Res.string.task_recurrence_monthly)
  map.put("task_recurrence_none", Res.string.task_recurrence_none)
  map.put("task_recurrence_weekly", Res.string.task_recurrence_weekly)
  map.put("task_stats_done", Res.string.task_stats_done)
  map.put("task_stats_overdue", Res.string.task_stats_overdue)
  map.put("task_stats_total", Res.string.task_stats_total)
  map.put("task_status_done", Res.string.task_status_done)
  map.put("task_status_in_progress", Res.string.task_status_in_progress)
  map.put("task_status_todo", Res.string.task_status_todo)
  map.put("task_subject_optional_label", Res.string.task_subject_optional_label)
  map.put("task_title_label", Res.string.task_title_label)
  map.put("task_title_placeholder", Res.string.task_title_placeholder)
  map.put("task_tracker_title", Res.string.task_tracker_title)
  map.put("theme_dark", Res.string.theme_dark)
  map.put("theme_light", Res.string.theme_light)
  map.put("theme_system", Res.string.theme_system)
  map.put("timer_btn_end", Res.string.timer_btn_end)
  map.put("timer_btn_stop", Res.string.timer_btn_stop)
  map.put("timer_focused_today", Res.string.timer_focused_today)
  map.put("timer_history", Res.string.timer_history)
  map.put("timer_input_task", Res.string.timer_input_task)
  map.put("timer_label_working_on", Res.string.timer_label_working_on)
  map.put("timer_mantra_focus", Res.string.timer_mantra_focus)
  map.put("timer_mantra_long_break", Res.string.timer_mantra_long_break)
  map.put("timer_mantra_short_break", Res.string.timer_mantra_short_break)
  map.put("timer_recent_activity", Res.string.timer_recent_activity)
  map.put("timer_recording", Res.string.timer_recording)
  map.put("timer_session_focus", Res.string.timer_session_focus)
  map.put("timer_session_long_break", Res.string.timer_session_long_break)
  map.put("timer_session_short_break", Res.string.timer_session_short_break)
  map.put("timer_settings", Res.string.timer_settings)
  map.put("timer_stats_streak", Res.string.timer_stats_streak)
  map.put("timer_stats_today", Res.string.timer_stats_today)
  map.put("timer_stats_week", Res.string.timer_stats_week)
  map.put("timer_status_focusing", Res.string.timer_status_focusing)
  map.put("timer_status_paused", Res.string.timer_status_paused)
  map.put("timer_status_ready", Res.string.timer_status_ready)
  map.put("timer_stop", Res.string.timer_stop)
  map.put("timer_title", Res.string.timer_title)
  map.put("timer_view_all_history", Res.string.timer_view_all_history)
  map.put("tool_name", Res.string.tool_name)
  map.put("translator_coming_soon", Res.string.translator_coming_soon)
  map.put("translator_title", Res.string.translator_title)
  map.put("version_desc", Res.string.version_desc)
  map.put("version_format_args", Res.string.version_format_args)
  map.put("version_label", Res.string.version_label)
  map.put("weekly_review_card_desc", Res.string.weekly_review_card_desc)
  map.put("weekly_review_title", Res.string.weekly_review_title)
  map.put("welcome_desc", Res.string.welcome_desc)
  map.put("welcome_title", Res.string.welcome_title)
  map.put("workspace_format", Res.string.workspace_format)
}
